import gql from 'graphql-tag'
import {internalStatus} from "../../Constants/Constant"
import {ORDER_FRAGMENT_PROCESS_ORDERS} from "../subscription/Orders";

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '';
let intermediateCondition = '';
  if(cities && cities.length){
      cities.forEach(function(curnt){
        let clientStr = '{clientobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
        let pickupStr = '{pickuppartyobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
        let dropStr = '{droppingpartyobject: {_contains: {address:[{city: "'+ curnt.city +'"}]}}},'
        intermediateCondition = intermediateCondition + clientStr + pickupStr + dropStr
       })
    finalCondition = ', {_or: ['+ intermediateCondition +']}'
  }

export const GET_ORDERS = gql`
  query orders($startDate:timestamptz!, $endDate:timestamptz!, $priority: [Int!]){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{ priority: {_in: $priority}}${finalCondition}]}){
      id
      pickupDate
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
    }
  }
`
export const FILTER_ORDERS = gql`
query orders($startDate:timestamptz!, $endDate:timestamptz!, $pickupId: uuid!, $priority: [Int!]){
  orders(where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{ pickuppartyid: {_eq: $pickupId}}, { priority: {_in: $priority}}${finalCondition}]}) {
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalstatus
      externalstatus
      pickupDate
  }
}
`

export const GET_SINGLE_ORDER = gql`
query orders($orderId:uuid!){
  orders(where: {id: {_eq: $orderId}}) {
      id
      pickupDate
      createdAt
      updated_at
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      internalStatus{id name id}
      externalStatus {id name id}
      orderDetails {
        id
        lrObject
        dispactchVerification
        orderReadiness
        pickupConfirmation
        pickupPoint
        dropPoint
        loadedInTruck
        ewayBillNo
        isEwayBillVerified
        pickupVehicleAssignId
        materialSize
        cancellationReason
        PIckupTempo{
           id
           tempo {id name platNo}
           driverDetail {id name mobile}
          }
        PickupTruck{
           id
           truck {id name platNo}
           driverDetail {id name mobile}
          }
        transportVehicleAssignId
        truckOrder{
           id
           truck {id name platNo}
           driverDetail {id name mobile}
          }
       }
  }
}
`

export const GET_LAST_ORDER = gql`
query orders($createdAt:timestamptz!){
  orders(where: {createdAt: {_gte: $createdAt}}, order_by: {createdAt: desc}, limit: 1) {
      orderNumber
  }
}
`
export const GET_ORDER_BY_PARENTID = gql`
query orders($parentOrderId : uuid!){
  orders(where: {parentOrderId: {_eq: $parentOrderId}}, order_by: {createdAt: desc}, limit: 1) {
      orderNumber
  }
}
`

export const FILTER_KANBAN_ORDERS = gql`
  query ($searchFilter: String!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}}] }${finalCondition}]}){
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      materials
      priority
      note
      internalstatus
      externalstatus
      internalStatus{id name viewPath}
      externalStatus{id name }
      orderDetails {id pickupPoint dropPoint}
    }
  }
`
export const FILTER_ALL_ORDERS = gql`
  query ($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_neq: "912cba99-37cb-41fb-ae2e-2a472200af64"}},
    {internalstatus: {_neq: "ed2747e7-c86b-48c7-96db-b10c509c27cf"}},{internalstatus: {_neq: "24e00980-9a93-496c-b422-7b17a9ddfc2a"}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}] }${finalCondition}]}, order_by: {createdAt: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const FILTER_COMPLETED_ORDERS = gql`
  query ($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_eq: "ed2747e7-c86b-48c7-96db-b10c509c27cf"}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}] }${finalCondition}]}, order_by: {pickupDate: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const FILTER_CANCEL_ORDERS = gql`
  query ($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_eq: "24e00980-9a93-496c-b422-7b17a9ddfc2a"}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}] }${finalCondition}]}, order_by: {pickupDate: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const FILTER_REJECTED_ORDERS = gql`
  query ($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!, $clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_eq: "912cba99-37cb-41fb-ae2e-2a472200af64"}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}] }${finalCondition}]}, order_by: {pickupDate: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const GET_UNPICKED_ORDERS = gql`
  query orderDetails{
    orderDetails (where: {pickupVehicleAssignId: {_eq: null}}){
      order {
        id
        pickupDate
        clientobject
        pickuppartyobject
        droppingpartyobject
        materials
        priority
        note
        orderNumber
        internalstatus
        externalstatus
      }
    }
  }
`
export const GET_ORDER_NOTE_HISTORY = gql`
query notes($orderId:uuid!){
  notes(where: {orderId: {_eq: $orderId}}, order_by: {createdOn: desc}) {
    id
    note
    type
    CreatedBy{id name}
    createdOn
  }
}
`
export const FILTER_ORDERS_CITYWISE = gql`
query orders_cityWise($startDate:timestamptz!, $endDate:timestamptz!, $city:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lt: $endDate}},{internalstatus: {_neq: "912cba99-37cb-41fb-ae2e-2a472200af64"}},
     {_or: [{clientobject: {_contains: $city}}, {pickuppartyobject: {_contains: $city}}, {droppingpartyobject: {_contains: $city}}]}
     ${finalCondition}]}, order_by: {createdAt: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const FILTER_EXCEL_ORDERS_CITYWISE = gql`
  query orders_cityWise($searchFilter: String!, $lrName: jsonb!, $startDate:timestamptz!, $endDate:timestamptz!,$clientCity:jsonb!, $pickupCity:jsonb!, $dropCity:jsonb!){
    orders (where: {_and: [{ pickupDate: {_gte: $startDate}},{ pickupDate: {_lte: $endDate}},{internalstatus: {_neq: ${internalStatus.completed}}},
    {internalstatus: {_neq: ${internalStatus.rejected}}},{internalstatus: {_neq: ${internalStatus.cancel}}},
     {clientobject: {_contains: $clientCity}}, {pickuppartyobject: {_contains: $pickupCity}}, {droppingpartyobject: {_contains: $dropCity}},
     {_or: [{orderNumber: {_ilike: $searchFilter}},{Client: {name: {_ilike: $searchFilter}}},
     {PickupParty: {name: {_ilike: $searchFilter}}},{DropParty: {name: {_ilike: $searchFilter}}},{orderDetails: {lrObject: {_contains: $lrName}}}] }
     ${finalCondition}]}, order_by: {createdAt: desc}){
      ...order
    }
  }${ORDER_FRAGMENT_PROCESS_ORDERS}`

export const GET_ORDER_BY_ID_FOR_LR = gql`
query orders($id:uuid!){
  orders(where: {id: {_eq: $id}}) {
      id
      pickupDate
      createdAt
      updated_at
      clientobject
      pickuppartyobject
      droppingpartyobject
      materials
      priority
      note
      orderNumber
      pickuppartyid
      droppingpartyid
      internalstatus
      internalStatus{id name id}
      externalStatus {id name id}
      orderDetails {
        id
        lrObject
        dispactchVerification
        orderReadiness
        pickupConfirmation
        pickupPoint
        dropPoint
        loadedInTruck
        ewayBillNo
        isEwayBillVerified
        pickupVehicleAssignId
        transportVehicleAssignId
        materialSize
        cancellationReason
        PIckupTempo{
           id
           tempo {id name platNo}
           driverDetail {id name mobile}
          }
        PickupTruck{
           id
           truck {id name platNo}
           driverDetail {id name mobile}
          }
        transportVehicleAssignId
        truckOrder{
           id
           truck {id name platNo}
           driverDetail {id name mobile}
          }
       }
  }
}
`
